module.exports = new Promise((resolve, reject) => {
    const _fed = `shared/auth`;
    const _debug = typeof window !== 'undefined' && (window.__NIKE_FEDERATION_DEBUG__ || (window.location && window.location.search && window.location.search.indexOf('debug=fed') > -1));

    if (!window.__federation_urls__) window.__federation_urls__ = {};
    if (!window.__federation_loading__) window.__federation_loading__ = {};
    if (!window.__federation_init_promises__) window.__federation_init_promises__ = {};
    if (!window.__federation_scopes__) window.__federation_scopes__ = {};

    var _deepMergeScope = (target, source, label) => {
      Object.keys(source).forEach((pkg) => {
        if (!target[pkg]) {
          target[pkg] = source[pkg];
          if (_debug) console.log('[fed:' + _fed + '] ' + label + ' package: ' + pkg);
        } else {
          Object.keys(source[pkg]).forEach((ver) => {
            if (!target[pkg][ver]) {
              target[pkg][ver] = source[pkg][ver];
              if (_debug) console.log('[fed:' + _fed + '] ' + label + ' ' + pkg + '@' + ver);
            }
          });
        }
      });
    };

    const proxy = {
      name: `shared-auth-proxy`,
      get: (request, getScope) => {
        if (_debug) console.log('[fed:' + _fed + '] get(' + request + ')');
        if (!window.auth) {
          const isLoading = !!window.__federation_loading__['auth'];
          const msg = '[fed:' + _fed + '] get(' + request + ') called but window.auth is not available' + (isLoading ? ' (script still loading)' : ' (never loaded)');
          console.error(msg);
          return Promise.reject(new Error(msg));
        }
        const initPromise = window.__federation_init_promises__['auth'];
        if (initPromise && typeof initPromise.then === 'function') {
          if (_debug) console.log('[fed:' + _fed + '] get(' + request + ') waiting for init to complete before resolving');
          return initPromise.then(() => window.auth.get(request, getScope));
        }
        return window.auth.get(request, getScope);
      },
      init: (scope, initScope) => {
        const oldScope = __webpack_require__.S['default'];

        if (_debug) {
          console.log('[fed:' + _fed + '] init called');
          console.log('[fed:' + _fed + ']   oldScope exists: ' + !!oldScope + ', same ref: ' + (oldScope === scope));
          if (oldScope && oldScope !== scope) {
            console.log('[fed:' + _fed + ']   oldScope keys: ' + Object.keys(oldScope).join(', '));
            console.log('[fed:' + _fed + ']   scope keys: ' + Object.keys(scope).join(', '));
          }
        }

        if (oldScope && oldScope !== scope) {
          if (_debug) console.log('[fed:' + _fed + '] Scope mismatch - deep merging oldScope into scope');
          _deepMergeScope(scope, oldScope, 'pre-init merged');
        }

        try {
          const result = window.auth.init(scope, initScope);
          if (_debug) console.log('[fed:' + _fed + '] init started (storing promise for async dep loading)');
          window.__federation_init_promises__['auth'] = result;
          window.__federation_scopes__['auth'] = scope;
          return result;
        } catch(e) {
          if (_debug) console.warn('[fed:' + _fed + '] init caught: ' + (e && e.message || e));

          var acceptedScope = window.__federation_scopes__['auth'];
          if (acceptedScope && acceptedScope !== scope) {
            if (_debug) console.log('[fed:' + _fed + '] merging caller scope into accepted scope (container already initialized by another host)');
            _deepMergeScope(acceptedScope, scope, 'post-init merged');
          }

          const storedPromise = window.__federation_init_promises__['auth'];
          if (storedPromise) {
            if (_debug) console.log('[fed:' + _fed + '] returning stored init promise - ensures async shared deps finish loading before get() proceeds');
            return storedPromise;
          }
        }
      }
    };

    const getEnv = () => {
      const host = window.location.host;
      const pathname = window.location.pathname;
      const query = window.location.search;
      const params = new URLSearchParams(query);
      const validEnvs = 'dev|qa|stg|test|uat|sec2|sec|prd-dr|prddr|prd|dr';
      const envMatcher = new RegExp('\\b(?<env>' + validEnvs + ')\\b', 'i');
      const hostSuffixMatcher = new RegExp('(?<env>' + validEnvs + ')(?=\\.)', 'i');
      const pathMatcher = new RegExp(`^\/(?<env>${validEnvs})(?=\/|$)`, 'i');
      const init = window.pme_mfe_init || {};
      const envEvaluator = (env) => {
        var e = env.toLowerCase();
        switch (e) {
          case 'test': return 'stg';
          case 'prddr': return 'prd-dr';
          case 'dr': return 'prd-dr';
          default: return e;
        }
      };
      
      if (_debug) console.log('[fed:' + _fed + '] getEnv: host=' + host + ' query=' + query);

      const envParam = params.get('env');
      var envValue = envParam && envParam.match(envMatcher);
      envValue = envValue && envValue.groups && envValue.groups.env;
      if (envValue) {
        if (_debug) console.log('[fed:' + _fed + '] getEnv: resolved from URL param ?env=' + envParam + ' -> ' + envValue);
        return envEvaluator(envValue);
      }
      envValue = init.env;
      if (envValue) {
        if (_debug) console.log('[fed:' + _fed + '] getEnv: resolved from pme_mfe_init.env=' + envValue);
        return envEvaluator(envValue);
      }
      var hostMatch = host.match(hostSuffixMatcher);
      if (!hostMatch) hostMatch = host.match(envMatcher);
      envValue = hostMatch && hostMatch.groups && hostMatch.groups.env;
      if (envValue) {
        if (_debug) console.log('[fed:' + _fed + '] getEnv: resolved from hostname ' + host + ' -> ' + envValue);
        return envEvaluator(envValue);
      }
      const pathMatch = pathname.match(pathMatcher);
      envValue = pathMatch && pathMatch.groups && pathMatch.groups.env;
      if (envValue) {
        if (_debug) console.log('[fed:' + _fed + '] getEnv: resolved from path ' + pathname + ' -> ' + envValue);
        return envEvaluator(envValue);
      }
      if (_debug) console.log('[fed:' + _fed + '] getEnv: no env detected, defaulting to prd');
      return 'prd';
    };

    const remoteUrls = {"prd":"auth@https://core-auth.nike.net/remoteEntry.js","prd-dr":"auth@https://core-auth.nike.net/remoteEntry.js"};
    const resolvedEnv = getEnv();
    var resolvedUrl = remoteUrls[resolvedEnv];
    if (!resolvedUrl) {
      var fallbackEnv = remoteUrls['dev'] ? 'dev' : (remoteUrls['local'] ? 'local' : null);
      resolvedUrl = fallbackEnv && remoteUrls[fallbackEnv];
      if (resolvedUrl) {
        console.warn('[fed:' + _fed + '] No URL configured for env "' + resolvedEnv + '", falling back to "' + fallbackEnv + '". Available envs: ' + Object.keys(remoteUrls).join(', '));
      }
    }
    if (!resolvedUrl) {
      var msg = '[fed:' + _fed + '] No URL configured for env "' + resolvedEnv + '" and no fallback available. Available envs: ' + Object.keys(remoteUrls).join(', ');
      console.error(msg);
      reject(new Error(msg));
      return;
    }
    const remoteUrl = resolvedUrl.split('@')[1];
    if (_debug) console.log('[fed:' + _fed + '] env=' + resolvedEnv + ' url=' + remoteUrl);

    if (window.auth) {
      const existingUrl = window.__federation_urls__['auth'];
      if (!existingUrl) {
        console.warn('[fed:' + _fed + '] Remote "auth" was loaded externally (not by dynamic resolver). Resolver resolved to ' + remoteUrl + ' but using pre-existing container.');
        window.__federation_urls__['auth'] = 'external';
      } else if (existingUrl !== remoteUrl && existingUrl !== 'external') {
        console.warn('[fed:' + _fed + '] Remote "auth" already loaded from ' + existingUrl + ' (requested: ' + remoteUrl + '). Using existing.');
      } else if (_debug) {
        console.log('[fed:' + _fed + '] auth already on window, reusing');
      }
      resolve(proxy);
      return;
    }

    if (window.__federation_loading__['auth']) {
      if (_debug) console.log('[fed:' + _fed + '] concurrent load detected - another consumer is already loading this remote, waiting...');
      const waitStart = Date.now();
      window.__federation_loading__['auth']
        .then(() => {
          const waitMs = Date.now() - waitStart;
          if (_debug) console.log('[fed:' + _fed + '] concurrent wait resolved after ' + waitMs + 'ms, reusing window.auth');
          if (!window.auth) {
            const msg = '[fed:' + _fed + '] concurrent wait resolved but window.auth is still not defined';
            console.error(msg);
            reject(new Error(msg));
          } else {
            resolve(proxy);
          }
        })
        .catch((err) => {
          if (_debug) console.error('[fed:' + _fed + '] concurrent wait rejected: ' + (err && err.message || err));
          reject(err);
        });
      return;
    }

    if (_debug) console.log('[fed:' + _fed + '] first load - fetching remote entry...');
    window.__federation_urls__['auth'] = remoteUrl;
    const loadStart = Date.now();

    window.__federation_loading__['auth'] = new Promise((loadResolve, loadReject) => {
      const script = document.createElement('script');
      script.src = remoteUrl;
      script.onload = () => {
        const loadMs = Date.now() - loadStart;
        if (_debug) console.log('[fed:' + _fed + '] script loaded in ' + loadMs + 'ms, window.auth defined: ' + !!window.auth);
        loadResolve();
      };
      script.onerror = () => {
        const loadMs = Date.now() - loadStart;
        const msg = '[fed:' + _fed + '] FAILED to load remote entry after ' + loadMs + 'ms: ' + remoteUrl;
        console.error(msg);
        delete window.__federation_loading__['auth'];
        loadReject(new Error(msg));
      };
      document.head.appendChild(script);
    });

    window.__federation_loading__['auth']
      .then(() => {
        delete window.__federation_loading__['auth'];
        resolve(proxy);
      })
      .catch((err) => {
        reject(err);
      });
  });